import MainLayout from "../../layouts/mainLayout/mainLayout";
import styled from "styled-components";
import Menus from "../../components/hamburger/menus";
import HamburgerLay from "../../components/hamburger/hamburger";
import { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { initialStates, schema, staticLables, removeEmptyFields, pickDraftableFields } from "./static-content";
import { useTranslation } from "react-i18next";
import { HiMiniSparkles } from "react-icons/hi2";
import Input from "../../components/input/input";
import TextArea from "../../components/description/description";
import Dropdown from "../../components/dropdown/dropdown";
import CheckboxInput from "../../components/checkboxInput/checkboxInput";
import RadioInput from "../../components/radioinput/radioinput";
import { Col, Row } from "react-bootstrap";
import ErrorField from "../../components/errorField/errorField";
import { BsInfoCircleFill } from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { getEthinicities, retrieveSurveyDetails, checkLikesApplication, createLikesSurvey, getStates } from "../../services/apiCalls";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { createTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { ReactComponent as CalenderIcon } from "../../assets/icons/svg/calendarIcon.svg";
import { formatDate } from "../../utilities/commonFunctions";
import { Colors } from "../../utilities/colors";
import Button from "../../components/button/button";
import { useSelector } from "react-redux";
import LikesAlertModal from "../../components/alertModal/likes-alert";
import { toast } from "react-toastify";
import Loader from "../../components/loader/loader";
import { getLikesSurveyDraft, saveLikesSurveyDraft, removeLikesSurveyDraft } from "../../utilities/likesSurveyDraft";
import { hasEvaluationData } from "../../utilities/likesEvaluation";

const materialTheme = createTheme({
    palette: {
        primary: {
            main: "#D44B9C",
        },
    },
    overrides: {
        MuiPickersCalendarHeader: {
            switchHeader: {
                color: "#D44B9C",
            },
        },
    },
});

const PageWrapper = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 80vh;
  padding: 0 3rem;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: 1024px) {
    padding: 0 1.5rem 2rem;
  }

  @media (max-width: 767px) {
    padding: 0 12px 24px;
  }
`;

const CardWrapper = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
  background: #ffffff;
  border-radius: 10px;
  padding: 32px;

  @media (max-width: 767px) {
    padding: 20px 16px;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    padding: 18px 12px;
  }
`;

const DashboardWrapper = styled.div`
  @media (max-width: 1024px) {
    display: flex;
  }
`;

const HamburgerLayout = styled.div`
  @media (min-width: 1025px) {
    display: none;
  }
`;

const Title = styled.h1`
  width: 100%;
  min-width: 0;
  margin: 0 0 16px;
  color: #000000;
  font-size: 28px;
  font-weight: 500;
  line-height: 38px;
  overflow-wrap: anywhere;
  word-break: normal;

  @media (max-width: 767px) {
    font-size: 24px;
    line-height: 34px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
    line-height: 30px;
  }
`;

const SubHeader = styled.span`
color: black;
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: normal;
`

const BorderSection = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  padding: 20px;
  margin: 12px 0;
  border-radius: 10px;
  border: 1px solid #f5f4f4;
  overflow: hidden;

  form {
    width: 100%;
    min-width: 0;
  }

  @media (max-width: 767px) {
    padding: 16px;
    gap: 14px;
  }

  @media (max-width: 480px) {
    padding: 14px 10px;
  }
`;

const DescriptiopBadge = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  padding: 16px;
  margin: 0 0 28px;
  background: #ffffff;
  border: 1px solid #e685b5;
  border-radius: 8px;
  gap: 10px;

  svg {
    width: 20px;
    height: 20px;
    min-width: 20px;
    color: #d63384;
    margin-top: 2px;
  }

  span {
    min-width: 0;
    margin: 0;
    color: #525252;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    overflow-wrap: anywhere;
  }

  @media (max-width: 480px) {
    padding: 14px 12px;
    margin-bottom: 24px;

    span {
      font-size: 14px;
      line-height: 22px;
    }
  }
`;

const FormGrouper = styled.div`
width: 100%;
margin-bottom: 24px;
`;

const FormLabel = styled.h3`
color: #202020;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: 24px;
margin: 0;
margin-bottom: 12px;
`;

const FormLabel2 = styled.h3`
color: #525252;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
margin: 0;
margin-bottom: 12px;
`;

const SectionLabelwrapper = styled.div`
  width: 100%;
  padding-bottom: 15px;
  margin: 0;
  border-bottom: 1px solid #E9ECEF;

  h3 {
  color: #D04C8D;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  }
`;

const StateRow = styled(Row)`
  width: 100%;
  min-width: 0;
  margin: 12px 0;
  align-items: center;

  > [class*="col"] {
    min-width: 0;
  }

  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: minmax(130px, 42%) minmax(0, 1fr);
    column-gap: 12px;
    row-gap: 8px;
    margin: 14px 0;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    margin: 18px 0;
  }
`;

const StateCol = styled(Col)`
  min-width: 0;
  padding: 0;
  display: flex;
  align-items: center;

  span {
    color: #d04c8d;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }

  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
  }
`;

const StatesGrid = styled.div`
  width: 100%;
  min-width: 0;

  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  box-sizing: border-box;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const StateField = styled.div`
  width: 100%;
  min-width: 0;

  > * {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }
`;

const StateDropdownCol = styled(StateCol)`
  width: 100%;
  min-width: 0;

  > * {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }
`;
const FormContent = styled.div`
  width: 100%;
  min-width: 0;
  padding-top: 24px;
  box-sizing: border-box;

  input,
  textarea,
  select {
    max-width: 100%;
    box-sizing: border-box;
  }

  @media (max-width: 767px) {
    padding-top: 20px;
  }
`;

const ResponsiveOptionRow = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px 24px;

  > * {
    min-width: 0;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const RatingDropdownCol = styled(StateCol)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  > * {
    width: 100%;
  }
`;

const LabelIconWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: flex-start;
align-items: center;
gap: 5px;
margin-bottom: 12px;
${FormLabel} {
    margin: 0;
  }

svg {
width: 16.667px;
height: 16.667px;
min-width: 17px;
min-height: 17px;
flex-shrink: 0;
color: #A5A0A0
}

.company-state-tooltip {
background-color: #aaa7aa !important;
color: #ffffff !important;
border-radius: 10px !important;
padding: 10px 16px !important;
font-size: 16px !important;
font-weight: 400 !important;
line-height: 22px !important;
opacity: 1 !important;
max-width: 320px;
}
`

const RaceOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const CalenderIconWrapper = styled.div`
  position: absolute;
  right: 1rem;
  top: 0.5rem;
  cursor: default;
`;

const DateRow = styled.div`
  width: 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const DateCol = styled.div`
  width: 100%;
  min-width: 0;
`;

const DatesWrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;

  > label {
    position: relative;
    display: block;
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
  }

  .MuiFormControl-root,
  .MuiInputBase-root {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
  }

  .MuiInputBase-input {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding-right: 48px;
  }

  .MuiInputBase-input.Mui-disabled {
    color: #a1a1a1;
    -webkit-text-fill-color: #a1a1a1;
    cursor: not-allowed;
  }
`;

const DateFieldInner = styled.div`
  width: 100%;
  padding: 0 14px;
  box-sizing: border-box;
`;

const TermsWrapper = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 8px;
`;

const TermsText = styled.label`
  min-width: 0;
  margin: 0;
  color: #202020;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  cursor: pointer;
  overflow-wrap: anywhere;

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 21px;
  }
`;

const TermsCheckbox = styled.input`
  appearance: none;
  -webkit-appearance: none;

  width: 18px;
  height: 18px;
  min-width: 18px;
  margin-top: 2px;

  border: 1px solid #d04c8d;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
  position: relative;

  &:checked {
    background: #d04c8d;
    border-color: #d04c8d;
  }

  &:checked::after {
    content: "✓";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -52%);
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(208, 76, 141, 0.2);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const ConfirmationWrapper = styled.div`
  width: 100%;
  padding: 24px;
  box-sizing: border-box;

  > span {
    display: block;
    width: 100%;
    max-width: 360px;
    margin: 0 auto 24px;

    color: #000;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }

  .button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    padding: 0;
  }

  .button-wrapper > * {
    width: 128px !important;
    min-width: 128px !important;
    max-width: 128px !important;
    height: 48px !important;
    margin: 0 !important;
  }

  .button-wrapper button {
    width: 128px !important;
    min-width: 128px !important;
    max-width: 128px !important;
    height: 48px !important;
    margin: 0 !important;
    padding: 0 10px !important;

    display: inline-flex !important;
    justify-content: center !important;
    align-items: center !important;

    line-height: 1 !important;
    white-space: nowrap;
  }
`;

const JobDescriptionTextarea = styled.textarea`
    background: ${Colors.inputBg};
    border-radius: 16px;
    border: 0;
    padding: 12px 20px;
    outline: none;
    width: 100%;
    min-height: 120px;
    max-height: 320px;
    box-sizing: border-box;
    font-family: inherit;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #202020;
    resize: ${({ $viewMode }) => ($viewMode ? "vertical" : "none")};
    overflow-y: ${({ $viewMode }) => ($viewMode ? "auto" : "hidden")};
    overflow-x: hidden;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    &::placeholder {
        color: ${Colors.inputText};
    }

    &:hover,
    &:focus,
    &:active {
        box-shadow: ${({ readOnly }) =>
        readOnly ? "none" : "0 0 0 1px #ff60b1"};
    }
    &:read-only {
        cursor: not-allowed;
        opacity: 1;
        -webkit-text-fill-color: #202020;
    }
`;

const CounterRow = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const LengthErrorMessage = styled.div`
  color: #d04c8d;
  font-family: "General Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

const CharacterCounter = styled.div`
  font-size: 12px;
  color: ${(props) => (props.$over ? "#d32f2f" : "#525252")};
  text-align: right;
  margin-left: auto;
`;

const FEEDBACK_MAX_LENGTH = 1000;
function FeedBackField({ value, onChange, disabled, t, viewMode }) {
    const textareaRef = useRef(null);
    const length = (value || "").length;
    const isOver = length >= FEEDBACK_MAX_LENGTH;

    useEffect(() => {
        const el = textareaRef.current;
        if (!el) return;

        el.style.height = "auto";

        if (viewMode) {
            el.style.height = `${Math.min(el.scrollHeight, 320)}px`;
        } else {
            el.style.height = `${el.scrollHeight}px`;
        }
    }, [value, viewMode]);

    const handleChange = (e) => {
        let inputValue = e.target.value.trimStart();
        if (inputValue.length > FEEDBACK_MAX_LENGTH) {
            inputValue = inputValue.slice(0, FEEDBACK_MAX_LENGTH);
        }
        onChange(inputValue);
    };

    return (
        <>
            <JobDescriptionTextarea
                ref={textareaRef}
                value={value || ""}
                onChange={handleChange}
                readOnly={viewMode}
                $viewMode={viewMode}
                placeholder={t("Please share your feedback")}
                maxLength={FEEDBACK_MAX_LENGTH}
            />

            <CounterRow>
                {!viewMode && (
                    <div>
                        {isOver && (
                            <LengthErrorMessage>
                                {t("Maximum 1000 characters allowed")}
                            </LengthErrorMessage>
                        )}
                    </div>
                )}

                <CharacterCounter $over={isOver}>
                    {length}/{FEEDBACK_MAX_LENGTH}
                </CharacterCounter>
            </CounterRow>
        </>
    );
}

export default function LikesInternEvaluationForm() {
    const { t } = useTranslation();
    const formValues = useSelector((state) => state.selfIntroOne.value);
    const [isOpenham, setOpenHam] = useState(false);
    const [states, setStates] = useState([]);
    const [races, setRaces] = useState([]);
    const tooltiplabel = "This field is editable, if required";
    const ratingTooltip = "Scale 1 (lowest) to Scale 10 (highest)";
    const [termCondition, setTermCondition] = useState(0);
    const [termsError, setTermsError] = useState("");
    const [viewMode, setViewMode] = useState(false);
    const [submitedClicked, setSubmitClicked] = useState(false);
    const [internId, setInternId] = useState("");
    const [surveyData, setSurveyData] = useState([]);
    const [prefilData, setPrefil] = useState({});
    const [showConfirmationModal, setShowConfirmation] = useState(false);
    const [loading, setLoading] = useState(false);
    // set whenever the survey state could not be determined (intern id missing,
    // or the evaluation could not be retrieved). Submission then fails closed,
    // because the user may already have submitted the survey.
    const [loadError, setLoadError] = useState(false);
    // id of the intern whose saved draft has already been merged into the form.
    // Stored as an id (not a boolean) so it can never stay "hydrated" across an
    // intern id change: the autosave effect stays disabled until the new id has
    // been loaded and reset() has run.
    const [hydratedInternId, setHydratedInternId] = useState(null);
    const draftHydrated =
        !!internId && String(hydratedInternId) === String(internId);
    const {
        watch,
        getValues,
        control,
        setError,
        setValue,
        formState: { errors },
        handleSubmit,
        reset,
        clearErrors
    } = useForm({
        defaultValues: { ...initialStates },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    })
    const formVal = watch();

    const formatIcNumber = (val = "") => {
        const numbersOnly = String(val).replace(/\D/g, "").slice(0, 12);

        if (numbersOnly.length <= 6) {
            return numbersOnly;
        }
        if (numbersOnly.length <= 8) {
            return `${numbersOnly.slice(0, 6)}-${numbersOnly.slice(6)}`;
        }
        return `${numbersOnly.slice(0, 6)}-${numbersOnly.slice(6, 8)}-${numbersOnly.slice(8)}`;
    };

    const checkForLikes = async (id_number) => {
        const { data, status } = await checkLikesApplication({ ic_number: id_number });
        if (data && status === 200 && data?.intern_id) {
            // loadError is cleared by fetchSurveydata once the evaluation is
            // actually retrieved; clearing it here would race with that call,
            // because this effect re-runs on every formValues identity change
            setInternId(data?.intern_id)
        } else {
            // without an intern id the evaluation can never be fetched, so the
            // form must not be offered as an empty, submittable one
            setLoadError(true);
            toast.error(t("Unable to fetch the details"));
        }
    }

    const getStateValue = (value) => {
        if (value === null || value === undefined || value === "") {
            return "";
        }

        const numberValue = Number(value);

        return Number.isNaN(numberValue) ? "" : numberValue;
    };

    const fetchSurveydata = async (id) => {
        setLoading(true);
        try {
            const { data, status } = await retrieveSurveyDetails(id);

            // onLikesApiCall never throws: a failure arrives here as a non-200
            // (or undefined) status, so it has to be handled explicitly or the
            // page would stay on the loader forever
            if (!data || status !== 200) {
                setLoadError(true);
                toast.error(t("Unable to fetch the details"));
                return;
            }

            setLoadError(false);

            const prefill = data?.data?.prefill || {};
            const evaluation = data?.data?.evaluation || null;

            setPrefil(prefill);
            setSurveyData(evaluation);

            const hasEvaluation = hasEvaluationData(evaluation);

            const prefillValues = {
                institution_state: getStateValue(prefill?.institution_state),
                hometown_state:
                    Number(prefill?.hometown_state) ??
                    "",
                company_state:
                    Number(prefill?.company_state) ??
                    "",
                race:
                    Number(prefill?.race) ??
                    "",
                gender: prefill?.gender ?? "",
                institution_name:
                    prefill?.institution_name ?? "",
                academic_qualification:
                    prefill?.academic_qualification ?? "",
                company_name:
                    prefill?.company_name ?? "",
                internship_start_date:
                    prefill?.internship_start_date ?? "",
                internship_end_date:
                    prefill?.internship_end_date ?? "",
            };

            if (hasEvaluation) {
                reset({
                    ...initialStates,
                    ...prefillValues,
                    ...evaluation,
                    institution_state: getStateValue(
                        evaluation?.institution_state
                    ),
                    hometown_state:
                        Number(evaluation?.hometown_state) ??
                        "",
                    company_state:
                        Number(evaluation?.company_state) ??
                        "",
                    race:
                        Number(evaluation?.race) ??
                        "",
                    why_choose_this_company:
                        evaluation?.why_choose_this_company || [],
                    platform_used_to_secure_offer:
                        evaluation?.platform_used_to_secure_offer || [],
                    concerns_getting_hired:
                        evaluation?.concerns_getting_hired || [],
                    types_of_work_duties:
                        evaluation?.types_of_work_duties || [],
                    challenges_faced:
                        evaluation?.challenges_faced || [],
                    support_required:
                        evaluation?.support_required || [],
                    consider_diff_fields_of_study: 
                        evaluation?.consider_diff_fields_of_study === true? 1 : 0,
                    work_on_projects: 
                        evaluation?.work_on_projects === true? 1 : 0,
                });

                setTermCondition(1);
                // server data always wins once an evaluation exists
                removeLikesSurveyDraft(id);
                setViewMode(true);
            } else {
                const draft = getLikesSurveyDraft(id);

                reset({
                    ...initialStates,
                    ...prefillValues,
                    ...(draft?.values ? pickDraftableFields(draft.values) : {}),
                });

                setTermCondition(draft ? (draft.termCondition ? 1 : 0) : 0);
                setViewMode(false);
                // only now may the autosave effect write, otherwise it would
                // overwrite the saved draft with the empty initial values
                setHydratedInternId(id);
            }
        } finally {
            // exactly one exit point for the loader, on every path
            setLoading(false);
        }
    }

    const dateChange = (name, val) => {
        setValue(name, formatDate(val));
        switch (name) {
            case "internship_start_date":
                setValue("internship_end_date", "");
                break;
        }
    };

    const fetchStateLies = async () => {
        const { data, status } = await getStates(132);
        if (status === 200) {
            const state = data.data;
            const stateList = state.map((x) => {
                return { ...x, label: x.Name, value: x.Id };
            });
            setStates(stateList);
        }
    }

    const fetchRaces = async () => {
        const { data, status } = await getEthinicities();
        if (status === 200) {
            const race = data.data;
            const newRace = race.map((x) => {
                return { ...x, label: x.Name, value: x.Id };
            });
            setRaces(newRace);
        }
    }

    const preventLeadingSpace = (onChange) => (e) => {
        const value = e.target.value.replace(/^\s+/, "");
        onChange(value);
    };

    const SurveyConfirmation = () => {
        return (
            <ConfirmationWrapper>
                <span>{t("Are you sure you want to submit this LiKES Intern Experience Survey form?")}</span>
                <div className="button-wrapper">
                    <Button name={t("Cancel")} type="buttom" onClick={() => {
                        setSubmitClicked(false);
                        setShowConfirmation(false);
                    }} secondary />
                    <Button name={t("Confirm")} type="button" onClick={onSubmitSurvey} disabled={submitedClicked} />
                </div>
            </ConfirmationWrapper>
        )
    }

    const onSubmitSurvey = async () => {
        setSubmitClicked(true);
        const vals = { ...formVal };
        const payload = removeEmptyFields(vals);

        const { data, status }= await createLikesSurvey(internId, payload);
        if(data && status === 200){
            setSubmitClicked(false);
            toast.success(t("Intern evaluation has been submitted"));
            removeLikesSurveyDraft(internId);
            fetchSurveydata(internId);
            setShowConfirmation(false);
        }else{
            setSubmitClicked(false);
            toast.error(t(data?.message))
        }
    }

    const onHandleSubmitForm = () => {
        if (termCondition === 0) {
            setTermsError(t("Please accept the Terms & Conditions before proceeding"));

            requestAnimationFrame(() => {
                document
                    .querySelector('[data-field="terms_condition"]')
                    ?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
            });

            return;
        }

        setTermsError("");
        setShowConfirmation(true);
    }

    const onHandleError = (formErrors) => {
        const firstErrorField = Object.keys(formErrors || {})[0];

        if (!firstErrorField) return;

        const fieldMap = {
            institution_state: "states-info",
            hometown_state: "states-info",
            company_state: "states-info",

            why_choose_this_company_other: "why_choose_this_company",
            platform_used_to_secure_offer_other: "platform_used_to_secure_offer",
            concerns_getting_hired_other: "concerns_getting_hired",
            types_of_work_duties_other: "types_of_work_duties",
            challenges_faced_other: "challenges_faced",
            support_required_other: "support_required",
            offered_job_industry_other: "offered_job_industry",

            internship_start_date: "internship_date",
            internship_end_date: "internship_date",

            technical_skills_rating: "scale-rating",
            soft_skills_rating: "scale-rating",
            business_acumen_rating: "scale-rating",
            feedback_satisfaction_rating: "scale-rating",
            market_experience_rating: "scale-rating",
            overall_satisfaction_rating: "scale-rating",

            terms_condition: "terms-condition",
        };

        const targetField = fieldMap[firstErrorField] || firstErrorField;

        requestAnimationFrame(() => {
            const targetElement = document.querySelector(
                `[data-field="${targetField}"]`
            );

            if (!targetElement) return;

            targetElement.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });

            const inputElement = targetElement.querySelector(
                "input, textarea, select, button"
            );

            inputElement?.focus({
                preventScroll: true,
            });
        });

        if (termCondition === 0) {
            setTermsError("Please accept the Terms & Conditions before proceeding")
        }
    }
    useEffect(() => {
        fetchRaces();
        fetchStateLies();
    }, [])

    useEffect(() => {
        if (internId) {
            fetchSurveydata(internId)
        }
    }, [internId]);

    useEffect(() => {
        if (formValues) {
            checkForLikes(formValues?.id_number)
        }
    }, [formValues])

    useEffect(() => {
        if (!internId || viewMode || !draftHydrated) return;

        let timer = null;

        const persist = (values) => {
            saveLikesSurveyDraft(internId, {
                values: pickDraftableFields(values),
                termCondition,
            });
        };

        // immediate write so a terms-only change is captured
        persist(getValues());

        const subscription = watch((values) => {
            clearTimeout(timer);
            timer = setTimeout(() => persist(values), 400);
        });

        // flush any pending debounce before the page unloads
        const onBeforeUnload = () => persist(getValues());
        window.addEventListener("beforeunload", onBeforeUnload);

        return () => {
            clearTimeout(timer);
            subscription.unsubscribe();
            window.removeEventListener("beforeunload", onBeforeUnload);
        };
    }, [watch, getValues, internId, viewMode, draftHydrated, termCondition])

    return (
        <MainLayout>
            <PageWrapper>
                <DashboardWrapper>
                    <HamburgerLayout>
                        <HamburgerLay toggled={isOpenham} toggle={setOpenHam} />
                    </HamburgerLayout>
                    {isOpenham && <Menus onClose={() => setOpenHam(false)} />}
                </DashboardWrapper>

                <CardWrapper>
                    <Title>{t(staticLables?.header)}</Title>
                    <BorderSection>
                        <SubHeader>{t(staticLables?.subHeader)}</SubHeader>
                        <DescriptiopBadge>
                            <HiMiniSparkles />
                            <span>{t(staticLables?.description)}</span>
                        </DescriptiopBadge>
                        {loading ? (
                            <Loader />
                        ) : (
                            <form onSubmit={handleSubmit(onHandleSubmitForm, onHandleError)}>
                                <SectionLabelwrapper>
                                    <h3>{t(staticLables?.section1)}</h3>
                                </SectionLabelwrapper>

                                <FormContent>
                                    <FormGrouper>
                                        <FormLabel>{t(staticLables?.fullName)}*</FormLabel>
                                        <Input
                                            placeholder={t("Full name")}
                                            value={prefilData?.full_name}
                                            disabled
                                        />
                                    </FormGrouper>

                                    <FormGrouper>
                                        <FormLabel>{t(staticLables?.myKad)}*</FormLabel>
                                        <Input
                                            placeholder={t("IC Number")}
                                            value={formatIcNumber(prefilData?.ic_number)}
                                            disabled
                                        />
                                    </FormGrouper>

                                    <FormGrouper data-field="states-info">
                                        <FormLabel>{t(staticLables?.statelabel)}</FormLabel>
                                            <StatesGrid>
                                                <StateField>
                                                    <FormLabel>{t(staticLables?.insitutionState)}*</FormLabel>
                                                    <Controller
                                                        name="institution_state"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <Dropdown
                                                                options={states}
                                                                placeholder={t("Please enter institution state")}
                                                                val={field?.value}
                                                                label={(states?.find((itm) => itm?.Id === field?.value))?.label}
                                                                change={(val) => field?.onChange(val?.Id)}
                                                                disable={viewMode}
                                                            />
                                                        )}
                                                    />
                                                    {errors?.institution_state && (
                                                        <ErrorField err={t(errors?.institution_state?.message)} />
                                                    )}
                                                </StateField>
                                                <StateField>
                                                    <FormLabel>{t(staticLables?.hometownState)}*</FormLabel>
                                                    <Controller
                                                        name="hometown_state"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <Dropdown
                                                                options={states}
                                                                placeholder={t("Please enter hometown state")}
                                                                val={field?.value}
                                                                label={(states?.find((itm) => itm?.Id === field?.value))?.label}
                                                                change={(val) => field?.onChange(val?.Id)}
                                                                disable
                                                            />
                                                        )}
                                                    />
                                                    {errors?.hometown_state && (
                                                        <ErrorField err={t(errors?.hometown_state?.message)} />
                                                    )}
                                                </StateField>
                                                <StateField>
                                                    <FormLabel>{t(staticLables?.companyState)}*</FormLabel>
                                                    <Controller
                                                        name="company_state"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <Dropdown
                                                                options={states}
                                                                placeholder={t("Please enter company state")}
                                                                val={field?.value}
                                                                label={(states?.find((itm) => itm?.Id === field?.value))?.label}
                                                                change={(val) => field?.onChange(val?.Id)}
                                                                disable
                                                            />
                                                        )}
                                                    />
                                                    {errors?.company_state && (
                                                        <ErrorField err={t(errors?.company_state?.message)} />
                                                    )}
                                                </StateField>
                                            </StatesGrid>
                                    </FormGrouper>

                                    <FormGrouper data-field="race">
                                        <LabelIconWrapper>
                                            <FormLabel>{t(staticLables?.race)}*</FormLabel>
                                                {/* {!viewMode && (
                                                    <>
                                                        <BsInfoCircleFill data-tip={t(tooltiplabel)} data-for="race-state" />
                                                        <ReactTooltip
                                                            id="race-state"
                                                            place="right"
                                                            effect="solid"
                                                            offset={{ left: 4 }}
                                                            className="company-state-tooltip"
                                                            arrowColor="#aaa7aa"
                                                        />
                                                    </>
                                                )} */}
                                        </LabelIconWrapper>
                                        <Controller
                                            name="race"
                                            control={control}
                                            render={({ field }) => (
                                                <RaceOptionsWrapper>
                                                    {races?.map((itm) => (
                                                        <RadioInput
                                                            key={itm.value}
                                                            name={field.name}
                                                            label={t(itm.label)}
                                                            checked={field.value === itm.value}
                                                            onChange={() => field.onChange(itm.value)}
                                                            disabled
                                                        />
                                                    ))}
                                                </RaceOptionsWrapper>
                                            )}
                                        />
                                        {errors?.race && (
                                            <ErrorField err={t(errors?.race?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="gender">
                                        <LabelIconWrapper>
                                            <FormLabel>{t(staticLables?.gender)}*</FormLabel>
                                                {/* {!viewMode && (
                                                    <>
                                                        <BsInfoCircleFill data-tip={t(tooltiplabel)} data-for="gender-state" />
                                                        <ReactTooltip
                                                            id="gender-state"
                                                            place="right"
                                                            effect="solid"
                                                            offset={{ left: 4 }}
                                                            className="company-state-tooltip"
                                                            arrowColor="#aaa7aa"
                                                        />
                                                    </>
                                                )} */}
                                        </LabelIconWrapper>
                                        <Controller
                                            name="gender"
                                            control={control}
                                            render={({ field }) => (
                                                <ResponsiveOptionRow>
                                                    {staticLables?.genderOption?.map((itm) => (
                                                        <RadioInput
                                                            key={itm.value}
                                                            name={field.name}
                                                            label={t(itm.label)}
                                                            checked={field.value === itm.value}
                                                            onChange={() => field.onChange(itm.value)}
                                                            disabled
                                                        />
                                                    ))}
                                                </ResponsiveOptionRow>
                                            )}
                                        />
                                        {errors?.gender && (
                                            <ErrorField err={t(errors?.gender?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="institution_name">
                                        <LabelIconWrapper>
                                            <FormLabel>{t(staticLables?.instiName)}*</FormLabel>
                                                {/* {!viewMode && (
                                                    <>
                                                        <BsInfoCircleFill data-tip={t(tooltiplabel)} data-for="insti-state" />
                                                        <ReactTooltip
                                                            id="insti-state"
                                                            place="right"
                                                            effect="solid"
                                                            offset={{ left: 4 }}
                                                            className="company-state-tooltip"
                                                            arrowColor="#aaa7aa"
                                                        />
                                                    </>
                                                )} */}
                                        </LabelIconWrapper>
                                        <Controller
                                            name="institution_name"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    placeholder={t("Institution name")}
                                                    value={field?.value}
                                                    onChange={preventLeadingSpace(field?.onChange)}
                                                    disabled
                                                />
                                            )}
                                        />
                                        {errors?.institution_name && (
                                            <ErrorField err={t(errors?.institution_name?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="academic_qualification">
                                        <LabelIconWrapper>
                                            <FormLabel>{t(staticLables?.academicQualification)}*</FormLabel>
                                                {/* {!viewMode && (
                                                    <>
                                                        <BsInfoCircleFill data-tip={t(tooltiplabel)} data-for="academic-state" />
                                                        <ReactTooltip
                                                            id="academic-state"
                                                            place="right"
                                                            effect="solid"
                                                            offset={{ left: 4 }}
                                                            className="company-state-tooltip"
                                                            arrowColor="#aaa7aa"
                                                        />
                                                    </>
                                                )} */}
                                        </LabelIconWrapper>
                                        <Controller
                                            name="academic_qualification"
                                            control={control}
                                            render={({ field: { value, onChange } }) => (
                                                <Dropdown
                                                    placeholder={t("Academic qualification")}
                                                    options={staticLables?.academicOption?.map((item) => ({
                                                        ...item,
                                                        label: t(item.label),
                                                    }))}
                                                    val={value}
                                                    label={t(staticLables?.academicOption?.find((itm) => itm?.value === value)?.label)}
                                                    change={(val) => onChange(val?.value)}
                                                    disable
                                                />
                                            )}
                                        />
                                        {errors?.academic_qualification && (
                                            <ErrorField err={t(errors?.academic_qualification?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="field_of_study">
                                        <FormLabel>{t(staticLables?.fieldOfStudy)}*</FormLabel>
                                            <Controller
                                                name="field_of_study"
                                                control={control}
                                                render={({ field }) => {
                                                    const selectedOption =
                                                        staticLables?.fieldOfStudyOption?.find(
                                                            (option) => option.label === field.value
                                                        );

                                                    return (
                                                        <Dropdown
                                                            placeholder={t("Select field of study")}
                                                            val={selectedOption?.value || ""}
                                                            options={staticLables?.fieldOfStudyOption?.map((item) => ({
                                                                ...item,
                                                                label: t(item.label),
                                                            }))}
                                                            label={selectedOption ? t(selectedOption.label) : ""}
                                                            change={(selected) => {
                                                                const originalOption =
                                                                    staticLables?.fieldOfStudyOption?.find(
                                                                        (item) => item.value === selected?.value
                                                                    );

                                                                field.onChange(originalOption?.label || "");

                                                                if (originalOption?.label !== "Others") {
                                                                    setValue("field_of_study_other", "");
                                                                    clearErrors("field_of_study_other");
                                                                }
                                                            }}
                                                            disable={viewMode}
                                                        />
                                                    );
                                                }}
                                            />

                                        {formVal?.field_of_study === "Other" && (
                                            <Controller
                                            name="field_of_study_other"
                                            control={control}
                                            render={({field}) =>(
                                                <div style={{ marginTop: "10px" }} data-field="field_of_study_other">
                                                    <Input
                                                        multiline
                                                        placeholder={t("Please specify other")}
                                                        value={field?.value}
                                                        onChange={field?.onChange}
                                                        disabled={viewMode}
                                                        maxLength={300}
                                                        maxLimitMessage={t("Maximum 300 characters allowed")}
                                                    />
                                                </div>
                                            )}
                                            />
                                        )}
                                        {errors?.field_of_study ? (
                                            <ErrorField err={t(errors?.field_of_study?.message)} />
                                        ) : errors?.field_of_study_other ? (
                                            <ErrorField err={t(errors?.field_of_study_other?.message)} />
                                        ): ""}
                                    </FormGrouper>
                                </FormContent>


                                <SectionLabelwrapper>
                                    <h3>{t(staticLables?.section2)}</h3>
                                </SectionLabelwrapper>
                                <FormContent>
                                    <FormGrouper data-field="company_name">
                                        <LabelIconWrapper>
                                            <FormLabel>{t(staticLables?.companyName)}*</FormLabel>
                                                {/* {!viewMode && (
                                                    <>
                                                        <BsInfoCircleFill data-tip={t(tooltiplabel)} data-for="company-name" />
                                                        <ReactTooltip
                                                            id="company-name"
                                                            place="right"
                                                            effect="solid"
                                                            offset={{ left: 4 }}
                                                            className="company-state-tooltip"
                                                            arrowColor="#aaa7aa"
                                                        />
                                                    </>
                                                )} */}
                                        </LabelIconWrapper>
                                        <Controller
                                            name="company_name"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    placeholder={t("Company name")}
                                                    value={field?.value}
                                                    onChange={preventLeadingSpace(field?.onChange)}
                                                    disabled
                                                />
                                            )}
                                        />
                                        {errors?.company_name && (
                                            <ErrorField err={t(errors?.company_name?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="internship_date">
                                        <LabelIconWrapper>
                                            <FormLabel>{t(staticLables?.dates)}*</FormLabel>
                                                {/* {!viewMode && (
                                                    <>
                                                        <BsInfoCircleFill data-tip={t(tooltiplabel)} data-for="dates" />
                                                        <ReactTooltip
                                                            id="dates"
                                                            place="right"
                                                            effect="solid"
                                                            offset={{ left: 4 }}
                                                            className="company-state-tooltip"
                                                            arrowColor="#aaa7aa"
                                                        />
                                                    </>
                                                )} */}
                                        </LabelIconWrapper>
                                        <DateRow>
                                            <DateCol>
                                                <FormLabel2>{t(staticLables?.startdate)}</FormLabel2>
                                                <DatesWrapper>
                                                    <Controller
                                                        name="internship_start_date"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <>
                                                                <label>
                                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                        <ThemeProvider theme={materialTheme}>
                                                                            <DatePicker
                                                                                // {...field}
                                                                                disableFuture
                                                                                variant="inline"
                                                                                format="dd/MM/yyyy"
                                                                                placeholder={t("dd/mm/yyyy")}
                                                                                views={["year", "month", "date"]}
                                                                                value={formVal.internship_start_date ? new Date(formVal.internship_start_date) : null}
                                                                                onChange={(val) => dateChange("internship_start_date", val)}
                                                                                fullWidth
                                                                                disabled

                                                                            />
                                                                        </ThemeProvider>
                                                                    </MuiPickersUtilsProvider>
                                                                    <CalenderIconWrapper>
                                                                        <CalenderIcon />
                                                                    </CalenderIconWrapper>
                                                                </label>
                                                            </>
                                                        )}
                                                    />
                                                    {errors?.internship_start_date && (
                                                        <ErrorField err={t(errors?.internship_start_date?.message)} />
                                                    )}
                                                </DatesWrapper>
                                            </DateCol>
                                            <DateCol>
                                                <FormLabel2>{t(staticLables?.enddate)}</FormLabel2>
                                                <DatesWrapper>
                                                    <Controller
                                                        name="internship_end_date"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <>
                                                                <label>
                                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                        <ThemeProvider theme={materialTheme}>
                                                                            <DatePicker
                                                                                // {...field}
                                                                                disableFuture
                                                                                variant="inline"
                                                                                format="dd/MM/yyyy"
                                                                                placeholder={t("dd/mm/yyyy")}
                                                                                views={["year", "month", "date"]}
                                                                                value={formVal.internship_end_date ? new Date(formVal.internship_end_date) : null}
                                                                                onChange={(val) => dateChange("internship_end_date", val)}
                                                                                fullWidth
                                                                                disabled
                                                                            />
                                                                        </ThemeProvider>
                                                                    </MuiPickersUtilsProvider>
                                                                    <CalenderIconWrapper>
                                                                        <CalenderIcon />
                                                                    </CalenderIconWrapper>
                                                                </label>
                                                            </>
                                                        )}
                                                    />
                                                    {errors?.internship_end_date && (
                                                        <ErrorField err={t(errors?.internship_end_date?.message)} />
                                                    )}
                                                </DatesWrapper>
                                            </DateCol>
                                        </DateRow>
                                    </FormGrouper>
                                </FormContent>


                                <SectionLabelwrapper>
                                    <h3>{t(staticLables?.section3)}</h3>
                                </SectionLabelwrapper>
                                <FormContent>
                                    <FormGrouper data-field="why_choose_this_company">
                                        <FormLabel>{t(staticLables?.whyCompany)}*</FormLabel>
                                        <Controller
                                            name="why_choose_this_company"
                                            control={control}
                                            render={({ field }) => {
                                                const selectedValues = field.value || [];

                                                const handleCheckboxChange = (option) => {
                                                    const label = option.label.trim();
                                                    const isSelected = selectedValues.includes(label);

                                                    let updatedValues;

                                                    if (isSelected) {
                                                        updatedValues = selectedValues.filter((item) => item !== label);
                                                        if (label === "Other") {
                                                            setValue("why_choose_this_company_other", "");
                                                            clearErrors("why_choose_this_company_other");
                                                        }
                                                    } else {
                                                        updatedValues = [...selectedValues, label];
                                                    }

                                                    field.onChange(updatedValues);
                                                };

                                                return (
                                                    <>
                                                        {staticLables?.whyOptions?.map((option) => {
                                                            const label = option.label.trim();

                                                            return (
                                                                <CheckboxInput
                                                                    key={option.value}
                                                                    name="wy-company"
                                                                    label={t(label)}
                                                                    checked={selectedValues.includes(label)}
                                                                    onChange={() => handleCheckboxChange({ ...option, label })}
                                                                    disabled={viewMode}
                                                                />
                                                            );
                                                        })}
                                                    </>
                                                );
                                            }}
                                        />
                                        {formVal?.why_choose_this_company?.includes("Other") && (
                                            <Controller
                                                name="why_choose_this_company_other"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <div style={{ marginTop: "10px" }} data-field="other_platform">
                                                        <Input
                                                            multiline
                                                            placeholder={t("Please specify other")}
                                                            value={value}
                                                            onChange={preventLeadingSpace(onChange)}
                                                            disabled={viewMode}
                                                            maxLength={300}
                                                            maxLimitMessage={t("Maximum 300 characters allowed")}
                                                        />
                                                    </div>
                                                )}
                                            />
                                        )}
                                        {errors?.why_choose_this_company ? (
                                            <ErrorField err={t(errors?.why_choose_this_company?.message)} />
                                        ) : errors?.why_choose_this_company_other ? (
                                            <ErrorField err={t(errors?.why_choose_this_company_other?.message)} />
                                        ) : ""}
                                    </FormGrouper>

                                    <FormGrouper data-field="applications_before_offered">
                                        <FormLabel>{t(staticLables?.howManyApplication)}*</FormLabel>
                                        <Controller
                                            name="applications_before_offered"
                                            control={control}
                                            render={({ field }) => (
                                                <RaceOptionsWrapper>
                                                    {staticLables?.howManyOption?.map((itm) => (
                                                        <RadioInput
                                                            key={itm.value}
                                                            name={field.name}
                                                            label={t(itm.label)}
                                                            checked={field.value === itm.label}
                                                            onChange={() => field.onChange(itm.label)}
                                                            disabled={viewMode}
                                                        />
                                                    ))}
                                                </RaceOptionsWrapper>
                                            )}
                                        />
                                        {errors?.applications_before_offered && (
                                            <ErrorField err={t(errors?.applications_before_offered?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="interviews_attended">
                                        <FormLabel>{t(staticLables?.interviews)}*</FormLabel>
                                        <Controller
                                            name="interviews_attended"
                                            control={control}
                                            render={({ field }) => (
                                                <RaceOptionsWrapper>
                                                    {staticLables?.interviewOption?.map((itm) => (
                                                        <RadioInput
                                                            key={itm.value}
                                                            name={field.name}
                                                            label={t(itm.label)}
                                                            checked={field.value === itm.label}
                                                            onChange={() => field.onChange(itm.label)}
                                                            disabled={viewMode}
                                                        />
                                                    ))}
                                                </RaceOptionsWrapper>
                                            )}
                                        />
                                        {errors?.interviews_attended && (
                                            <ErrorField err={t(errors?.interviews_attended?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="platform_used_to_secure_offer">
                                        <FormLabel>{t(staticLables?.platformLabel)}*</FormLabel>
                                        <Controller
                                            name="platform_used_to_secure_offer"
                                            control={control}
                                            render={({ field }) => {
                                                const selectedValues = field.value || [];

                                                const handleCheckboxChange = (option) => {
                                                    const label = option.label.trim();
                                                    const isSelected = selectedValues.includes(label);

                                                    let updatedValues;

                                                    if (isSelected) {
                                                        updatedValues = selectedValues.filter((item) => item !== label);
                                                        if (label === "Other") {
                                                            setValue("platform_used_to_secure_offer_other", "");
                                                            clearErrors("platform_used_to_secure_offer_other");
                                                        }
                                                    } else {
                                                        updatedValues = [...selectedValues, label];
                                                    }

                                                    field.onChange(updatedValues);
                                                };

                                                return (
                                                    <>
                                                        {staticLables?.platforms?.map((option) => {
                                                            const label = option.label.trim();

                                                            return (
                                                                <CheckboxInput
                                                                    key={option.value}
                                                                    name="platforms"
                                                                    label={t(label)}
                                                                    checked={selectedValues.includes(label)}
                                                                    onChange={() => handleCheckboxChange({ ...option, label })}
                                                                    disabled={viewMode}
                                                                />
                                                            );
                                                        })}
                                                    </>
                                                );
                                            }}
                                        />
                                        {formVal?.platform_used_to_secure_offer?.includes("Other") && (
                                            <Controller
                                                name="platform_used_to_secure_offer_other"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <div style={{ marginTop: "10px" }} data-field="other_platform">
                                                        <Input
                                                            multiline
                                                            placeholder={t("Please specify other")}
                                                            value={value}
                                                            onChange={preventLeadingSpace(onChange)}
                                                            disabled={viewMode}
                                                            maxLength={300}
                                                            maxLimitMessage={t("Maximum 300 characters allowed")}
                                                        />
                                                    </div>
                                                )}
                                            />
                                        )}
                                        {errors?.platform_used_to_secure_offer ? (
                                            <ErrorField err={t(errors?.platform_used_to_secure_offer?.message)} />
                                        ) : errors?.platform_used_to_secure_offer_other ? (
                                            <ErrorField err={t(errors?.platform_used_to_secure_offer_other?.message)} />
                                        ) : ""}
                                    </FormGrouper>

                                    <FormGrouper data-field="concerns_getting_hired">
                                        <FormLabel>{t(staticLables?.biggestConcern)}*</FormLabel>
                                        <Controller
                                            name="concerns_getting_hired"
                                            control={control}
                                            render={({ field }) => {
                                                const selectedValues = field.value || [];

                                                const handleCheckboxChange = (option) => {
                                                    const label = option.label.trim();
                                                    const isSelected = selectedValues.includes(label);

                                                    let updatedValues;

                                                    if (isSelected) {
                                                        updatedValues = selectedValues.filter((item) => item !== label);
                                                        if (label === "Other") {
                                                            setValue("concerns_getting_hired_other", "");
                                                            clearErrors("concerns_getting_hired_other");
                                                        }
                                                    } else {
                                                        updatedValues = [...selectedValues, label];
                                                    }

                                                    field.onChange(updatedValues);
                                                };

                                                return (
                                                    <>
                                                        {staticLables?.concerns?.map((option) => {
                                                            const label = option.label.trim();

                                                            return (
                                                                <CheckboxInput
                                                                    key={option.value}
                                                                    name="concerns"
                                                                    label={t(label)}
                                                                    checked={selectedValues.includes(label)}
                                                                    onChange={() => handleCheckboxChange({ ...option, label })}
                                                                    disabled={viewMode}
                                                                />
                                                            );
                                                        })}
                                                    </>
                                                );
                                            }}
                                        />
                                        {formVal?.concerns_getting_hired?.includes("Other") && (
                                            <Controller
                                                name="concerns_getting_hired_other"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <div style={{ marginTop: "10px" }} data-field="other_platform">
                                                        <Input
                                                            multiline
                                                            placeholder={t("Please specify other")}
                                                            value={value}
                                                            onChange={preventLeadingSpace(onChange)}
                                                            disabled={viewMode}
                                                            maxLength={300}
                                                            maxLimitMessage={t("Maximum 300 characters allowed")}
                                                        />
                                                    </div>
                                                )}
                                            />
                                        )}
                                        {errors?.concerns_getting_hired ? (
                                            <ErrorField err={t(errors?.concerns_getting_hired?.message)} />
                                        ) : errors?.concerns_getting_hired_other ? (
                                            <ErrorField err={t(errors?.concerns_getting_hired_other?.message)} />
                                        ) : ""}
                                    </FormGrouper>

                                    <FormGrouper data-field="receive_onboarding">
                                        <FormLabel>{t(staticLables?.receiveOnboarding)}*</FormLabel>
                                        <Controller
                                            name="receive_onboarding"
                                            control={control}
                                            render={({ field }) => (
                                                <RaceOptionsWrapper>
                                                    {staticLables?.onboardingOptions?.map((itm) => (
                                                        <RadioInput
                                                            key={itm.value}
                                                            name={field.name}
                                                            label={t(itm.label)}
                                                            checked={field.value === itm.label}
                                                            onChange={() => field.onChange(itm.label)}
                                                            disabled={viewMode}
                                                        />
                                                    ))}
                                                </RaceOptionsWrapper>
                                            )}
                                        />
                                        {errors?.receive_onboarding && (
                                            <ErrorField err={t(errors?.receive_onboarding?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="duties_match_job_description">
                                        <FormLabel>{t(staticLables?.likesEasy)}*</FormLabel>
                                        <Controller
                                            name="duties_match_job_description"
                                            control={control}
                                            render={({ field }) => (
                                                <ResponsiveOptionRow>
                                                    <RadioInput
                                                        name={"duties_match_job_description"}
                                                        label={t("Yes")}
                                                        checked={field.value === "Yes"}
                                                        onChange={() => field.onChange("Yes")}
                                                        disabled={viewMode}
                                                    />

                                                    <RadioInput
                                                        name={"duties_match_job_description"}
                                                        label={t("Partly")}
                                                        checked={field.value === "Partly"}
                                                        onChange={() => field.onChange("Partly")}
                                                        disabled={viewMode}
                                                    />

                                                    <RadioInput
                                                        name={"duties_match_job_description"}
                                                        label={t("No")}
                                                        checked={field.value === "No"}
                                                        onChange={() => field.onChange("No")}
                                                        disabled={viewMode}
                                                    />
                                                </ResponsiveOptionRow>
                                            )}
                                        />
                                        {errors?.duties_match_job_description && (
                                            <ErrorField err={t(errors?.duties_match_job_description?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field={"types_of_work_duties"}>
                                        <FormLabel>{t(staticLables?.typesOfDuty)}*</FormLabel>
                                        <Controller
                                            name="types_of_work_duties"
                                            control={control}
                                            render={({ field }) => {
                                                const selectedValues = field.value || [];

                                                const handleCheckboxChange = (option) => {
                                                    const label = option.label.trim();
                                                    const isSelected = selectedValues.includes(label);

                                                    let updatedValues;

                                                    if (isSelected) {
                                                        updatedValues = selectedValues.filter((item) => item !== label);
                                                        if (label === "Other") {
                                                            setValue("types_of_work_duties_other", "");
                                                            clearErrors("types_of_work_duties_other");
                                                        }
                                                    } else {
                                                        updatedValues = [...selectedValues, label];
                                                    }

                                                    field.onChange(updatedValues);
                                                };

                                                return (
                                                    <>
                                                        {staticLables?.duties?.map((option) => {
                                                            const label = option.label.trim();

                                                            return (
                                                                <CheckboxInput
                                                                    key={option.value}
                                                                    name="concerns"
                                                                    label={t(label)}
                                                                    checked={selectedValues.includes(label)}
                                                                    onChange={() => handleCheckboxChange({ ...option, label })}
                                                                    disabled={viewMode}
                                                                />
                                                            );
                                                        })}
                                                    </>
                                                );
                                            }}
                                        />
                                        {formVal?.types_of_work_duties?.includes("Other") && (
                                            <Controller
                                                name="types_of_work_duties_other"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <div style={{ marginTop: "10px" }} data-field="types_of_work_duties_other">
                                                        <Input
                                                            multiline
                                                            placeholder={t("Please specify other")}
                                                            value={value}
                                                            onChange={preventLeadingSpace(onChange)}
                                                            disabled={viewMode}
                                                            maxLength={300}
                                                            maxLimitMessage={t("Maximum 300 characters allowed")}
                                                        />
                                                    </div>
                                                )}
                                            />
                                        )}
                                        {errors?.types_of_work_duties ? (
                                            <ErrorField err={t(errors?.types_of_work_duties?.message)} />
                                        ) : errors?.types_of_work_duties_other ? (
                                            <ErrorField err={t(errors?.types_of_work_duties_other?.message)} />
                                        ) : ""}
                                    </FormGrouper>

                                    <FormGrouper data-field="receive_guidance">
                                        <FormLabel>{t(staticLables?.receiveGuidance)}*</FormLabel>
                                        <Controller
                                            name="receive_guidance"
                                            control={control}
                                            render={({ field }) => (
                                                <ResponsiveOptionRow>
                                                    <RadioInput
                                                        name={"receive_guidance"}
                                                        label={t("Yes, regularly")}
                                                        checked={field.value === "Yes, regularly"}
                                                        onChange={() => field.onChange("Yes, regularly")}
                                                        disabled={viewMode}
                                                    />

                                                    <RadioInput
                                                        name={"receive_guidance"}
                                                        label={t("Yes, sometimes")}
                                                        checked={field.value === "Yes, sometimes"}
                                                        onChange={() => field.onChange("Yes, sometimes")}
                                                        disabled={viewMode}
                                                    />

                                                    <RadioInput
                                                        name={"receive_guidance"}
                                                        label={t("No")}
                                                        checked={field.value === "No"}
                                                        onChange={() => field.onChange("No")}
                                                        disabled={viewMode}
                                                    />
                                                </ResponsiveOptionRow>
                                            )}
                                        />
                                        {errors?.receive_guidance && (
                                            <ErrorField err={t(errors?.receive_guidance?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="work_on_projects">
                                        <FormLabel>{t(staticLables?.workOnProject)}*</FormLabel>
                                        <Controller
                                            name="work_on_projects"
                                            control={control}
                                            render={({ field }) => (
                                                <ResponsiveOptionRow>
                                                    <RadioInput
                                                        name={"work_on_projects"}
                                                        label={t("Yes")}
                                                        checked={field.value === 1}
                                                        onChange={() => field.onChange(1)}
                                                        disabled={viewMode}
                                                    />

                                                    <RadioInput
                                                        name={"work_on_projects"}
                                                        label={t("No")}
                                                        checked={field.value === 0}
                                                        onChange={() => field.onChange(0)}
                                                        disabled={viewMode}
                                                    />
                                                </ResponsiveOptionRow>
                                            )}
                                        />
                                        {errors?.work_on_projects && (
                                            <ErrorField err={t(errors?.work_on_projects?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="scale-rating">
                                        <FormLabel>{t(staticLables?.scaleLabel)}</FormLabel>
                                        <StateRow>
                                            <StateCol>
                                                <span>{t("Linear Scale")}</span>
                                            </StateCol>
                                            <StateCol>
                                                <LabelIconWrapper>
                                                    <span>{t("Scale")}</span>
                                                    <BsInfoCircleFill data-tip={t(ratingTooltip)} data-for="rating-tip" />
                                                    <ReactTooltip
                                                        id="rating-tip"
                                                        place="right"
                                                        effect="solid"
                                                        offset={{ left: 4 }}
                                                        className="company-state-tooltip"
                                                        arrowColor="#aaa7aa"
                                                    />
                                                </LabelIconWrapper>
                                            </StateCol>
                                        </StateRow>
                                        {staticLables?.lineraScale?.map((itm) => {
                                            const fieldError = errors?.[itm.value];

                                            return (
                                                <StateRow key={itm.value}>
                                                    <StateCol>
                                                        <FormLabel>{t(itm.label)}*</FormLabel>
                                                    </StateCol>

                                                    <RatingDropdownCol>
                                                        <Controller
                                                            name={itm.value}
                                                            control={control}
                                                            render={({ field }) => (
                                                                <Dropdown
                                                                    placeholder="-"
                                                                    val={field.value}
                                                                    options={staticLables?.ratingOptions}
                                                                    label={
                                                                        staticLables?.ratingOptions.find(
                                                                            (option) => option.value === field.value
                                                                        )?.label
                                                                    }
                                                                    change={(option) => field.onChange(option?.value)}
                                                                    disable={viewMode}
                                                                />
                                                            )}
                                                        />

                                                        {fieldError && (
                                                            <ErrorField err={t(fieldError.message)} />
                                                        )}
                                                    </RatingDropdownCol>
                                                </StateRow>
                                            );
                                        })}
                                    </FormGrouper>

                                    <FormGrouper data-field={"challenges_faced"}>
                                        <FormLabel>{t(staticLables?.challengesFaced)}*</FormLabel>
                                        <Controller
                                            name="challenges_faced"
                                            control={control}
                                            render={({ field }) => {
                                                const selectedValues = field.value || [];

                                                const handleCheckboxChange = (option) => {
                                                    const label = option.label.trim();
                                                    const isSelected = selectedValues.includes(label);

                                                    let updatedValues;

                                                    if (isSelected) {
                                                        updatedValues = selectedValues.filter((item) => item !== label);
                                                        if (label === "Other") {
                                                            setValue("challenges_faced_other", "");
                                                            clearErrors("challenges_faced_other");
                                                        }
                                                    } else {
                                                        updatedValues = [...selectedValues, label];
                                                    }

                                                    field.onChange(updatedValues);
                                                };

                                                return (
                                                    <>
                                                        {staticLables?.challenges?.map((option) => {
                                                            const label = option.label.trim();

                                                            return (
                                                                <CheckboxInput
                                                                    key={option.value}
                                                                    name="concerns"
                                                                    label={t(label)}
                                                                    checked={selectedValues.includes(label)}
                                                                    onChange={() => handleCheckboxChange({ ...option, label })}
                                                                    disabled={viewMode}
                                                                />
                                                            );
                                                        })}
                                                    </>
                                                );
                                            }}
                                        />
                                        {formVal?.challenges_faced?.includes("Other") && (
                                            <Controller
                                                name="challenges_faced_other"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <div style={{ marginTop: "10px" }} data-field="challenges_faced_other">
                                                        <Input
                                                            multiline
                                                            placeholder={t("Please specify other")}
                                                            value={value}
                                                            onChange={preventLeadingSpace(onChange)}
                                                            disabled={viewMode}
                                                            maxLength={300}
                                                            maxLimitMessage={t("Maximum 300 characters allowed")}
                                                        />
                                                    </div>
                                                )}
                                            />
                                        )}
                                        {errors?.challenges_faced ? (
                                            <ErrorField err={t(errors?.challenges_faced?.message)} />
                                        ) : errors?.challenges_faced_other ? (
                                            <ErrorField err={t(errors?.challenges_faced_other?.message)} />
                                        ) : ""}
                                    </FormGrouper>

                                    <FormGrouper data-field={"support_required"}>
                                        <FormLabel>{t(staticLables?.supportRequire)}*</FormLabel>
                                        <Controller
                                            name="support_required"
                                            control={control}
                                            render={({ field }) => {
                                                const selectedValues = field.value || [];

                                                const handleCheckboxChange = (option) => {
                                                    const label = option.label.trim();
                                                    const isSelected = selectedValues.includes(label);

                                                    let updatedValues;

                                                    if (isSelected) {
                                                        updatedValues = selectedValues.filter((item) => item !== label);
                                                        if (label === "Other") {
                                                            setValue("support_required_other", "");
                                                            clearErrors("support_required_other");
                                                        }
                                                    } else {
                                                        updatedValues = [...selectedValues, label];
                                                    }

                                                    field.onChange(updatedValues);
                                                };

                                                return (
                                                    <>
                                                        {staticLables?.supportOption?.map((option) => {
                                                            const label = option.label.trim();

                                                            return (
                                                                <CheckboxInput
                                                                    key={option.value}
                                                                    name="concerns"
                                                                    label={t(label)}
                                                                    checked={selectedValues.includes(label)}
                                                                    onChange={() => handleCheckboxChange({ ...option, label })}
                                                                    disabled={viewMode}
                                                                />
                                                            );
                                                        })}
                                                    </>
                                                );
                                            }}
                                        />
                                        {formVal?.support_required?.includes("Other") && (
                                            <Controller
                                                name="support_required_other"
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <div style={{ marginTop: "10px" }} data-field="support_required_other">
                                                        <Input
                                                            multiline
                                                            placeholder={t("Please specify other")}
                                                            value={value}
                                                            onChange={preventLeadingSpace(onChange)}
                                                            disabled={viewMode}
                                                            maxLength={300}
                                                            maxLimitMessage={t("Maximum 300 characters allowed")}
                                                        />
                                                    </div>
                                                )}
                                            />
                                        )}
                                        {errors?.support_required ? (
                                            <ErrorField err={t(errors?.support_required?.message)} />
                                        ) : errors?.support_required_other ? (
                                            <ErrorField err={t(errors?.support_required_other?.message)} />
                                        ) : ""}
                                    </FormGrouper>

                                    <FormGrouper data-field="consider_diff_fields_of_study">
                                        <FormLabel>{t(staticLables?.undergoInternship)}*</FormLabel>
                                        <Controller
                                            name="consider_diff_fields_of_study"
                                            control={control}
                                            render={({ field }) => (
                                                <ResponsiveOptionRow>
                                                    <RadioInput
                                                        name={"consider_diff_fields_of_study"}
                                                        label={t("Yes")}
                                                        checked={field.value === 1}
                                                        onChange={() => field.onChange(1)}
                                                        disabled={viewMode}
                                                    />

                                                    <RadioInput
                                                        name={"consider_diff_fields_of_study"}
                                                        label={t("No")}
                                                        checked={field.value === 0}
                                                        onChange={() => field.onChange(0)}
                                                        disabled={viewMode}
                                                    />
                                                </ResponsiveOptionRow>
                                            )}
                                        />
                                        {errors?.consider_diff_fields_of_study && (
                                            <ErrorField err={t(errors?.consider_diff_fields_of_study?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="get_job_after_complete">
                                        <FormLabel>{t(staticLables?.jobOffer)}*</FormLabel>
                                        <Controller
                                            name="get_job_after_complete"
                                            control={control}
                                            render={({ field }) => (
                                                <ResponsiveOptionRow>
                                                    <RadioInput
                                                        name={"get_job_after_complete"}
                                                        label={t("Yes")}
                                                        checked={field.value === "Yes"}
                                                        onChange={() => field.onChange("Yes")}
                                                        disabled={viewMode}
                                                    />

                                                    <RadioInput
                                                        name={"get_job_after_complete"}
                                                        label={t("No")}
                                                        checked={field.value === "No"}
                                                        onChange={() => field.onChange("No")}
                                                        disabled={viewMode}
                                                    />

                                                    <RadioInput
                                                        name={"get_job_after_complete"}
                                                        label={t("No, but received offer elsewhere")}
                                                        checked={field.value === "No, but received offer elsewhere"}
                                                        onChange={() => field.onChange("No, but received offer elsewhere")}
                                                        disabled={viewMode}
                                                    />
                                                </ResponsiveOptionRow>
                                            )}
                                        />
                                        {errors?.get_job_after_complete && (
                                            <ErrorField err={t(errors?.get_job_after_complete?.message)} />
                                        )}
                                    </FormGrouper>

                                    {(formVal?.get_job_after_complete === "Yes" || formVal?.get_job_after_complete === "No, but received offer elsewhere") && (
                                        <>
                                            <FormGrouper data-field="type_of_job_contract_offer">
                                                <FormLabel>{t(staticLables?.offerContract)}*</FormLabel>
                                                <Controller
                                                    name="type_of_job_contract_offer"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <ResponsiveOptionRow>
                                                            <RadioInput
                                                                name={"type_of_job_contract_offer"}
                                                                label={t("Permanent")}
                                                                checked={field.value === "Permanent"}
                                                                onChange={() => field.onChange("Permanent")}
                                                                disabled={viewMode}
                                                            />

                                                            <RadioInput
                                                                name={"type_of_job_contract_offer"}
                                                                label={t("Contract")}
                                                                checked={field.value === "Contract"}
                                                                onChange={() => field.onChange("Contract")}
                                                                disabled={viewMode}
                                                            />
                                                        </ResponsiveOptionRow>
                                                    )}
                                                />
                                                {errors?.type_of_job_contract_offer && (
                                                    <ErrorField err={t(errors?.type_of_job_contract_offer?.message)} />
                                                )}
                                            </FormGrouper>
                                            <FormGrouper data-field="offered_job_industry">
                                                <FormLabel>{t(staticLables?.industryOffered)}*</FormLabel>
                                                <Controller
                                                    name="offered_job_industry"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <RaceOptionsWrapper>
                                                            {staticLables?.industries?.map((itm) => (
                                                                <RadioInput
                                                                    key={itm.value}
                                                                    name={field.name}
                                                                    label={t(itm.label)}
                                                                    checked={field.value === itm.label}
                                                                    onChange={() => field.onChange(itm.label)}
                                                                    disabled={viewMode}
                                                                />
                                                            ))}
                                                        </RaceOptionsWrapper>
                                                    )}
                                                />
                                                {formVal?.offered_job_industry === "Other" && (
                                                    <Controller
                                                        name="offered_job_industry_other"
                                                        control={control}
                                                        render={({ field: { value, onChange } }) => (
                                                            <div style={{ marginTop: "10px" }} data-field="offered_job_industry_other">
                                                                <Input
                                                                    multiline
                                                                    placeholder={t("Please specify other")}
                                                                    value={value}
                                                                    onChange={preventLeadingSpace(onChange)}
                                                                    disabled={viewMode}
                                                                    maxLength={300}
                                                                    maxLimitMessage={t("Maximum 300 characters allowed")}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                )}
                                                {errors?.offered_job_industry ? (
                                                    <ErrorField err={t(errors?.offered_job_industry?.message)} />
                                                ) : errors?.offered_job_industry_other ? (
                                                    <ErrorField err={t(errors?.offered_job_industry_other?.message)} />
                                                ) : ""}
                                            </FormGrouper>
                                        </>
                                    )}

                                    <FormGrouper data-field="overall_internship_experience">
                                        <FormLabel>{t(staticLables?.improveOverall)}*</FormLabel>
                                        <Controller
                                            name="overall_internship_experience"
                                            control={control}
                                            render={({ field }) => (
                                                <FeedBackField
                                                    value={field.value}
                                                    onChange={field.onChange}
                                                    viewMode={viewMode}
                                                    t={t}
                                                />
                                            )}
                                        />
                                        {errors?.overall_internship_experience && (
                                            <ErrorField err={t(errors?.overall_internship_experience?.message)} />
                                        )}
                                    </FormGrouper>

                                    <FormGrouper data-field="term-condition">
                                        <FormLabel>{t(staticLables?.termslabel)}</FormLabel>
                                        <TermsWrapper>
                                            <TermsCheckbox
                                                type="checkbox"
                                                id="terms_condition"
                                                checked={termCondition === 1}
                                                onChange={(e) => {
                                                    const checkedValue =
                                                        e.target.checked ? 1 : 0;

                                                    setTermCondition(checkedValue);
                                                    setTermsError("");
                                                }}
                                                disabled={viewMode}
                                            />

                                            <TermsText htmlFor="terms_condition">
                                                {t(staticLables?.termsCondition)}
                                            </TermsText>
                                        </TermsWrapper>
                                        {termsError && <ErrorField err={t(termsError)} />}
                                    </FormGrouper>
                                </FormContent>
                                {!viewMode && !loadError && (
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                        <Button name={t("Submit")} type="submit" />
                                    </div>
                                )}
                            </form>
                        )}
                    </BorderSection>
                    <LikesAlertModal
                        show={showConfirmationModal}
                        close={() => setShowConfirmation(false)}
                        content={<SurveyConfirmation />}
                        padding="0"
                        height="auto"
                    />
                </CardWrapper>
            </PageWrapper>
        </MainLayout>
    )
}